<template>
  <div class="page">
    <img :src="goodsInfo.imageUrl" alt class="img" />
    <AnnPopup v-model="annPop" @buttonClick="openCashierDesk"></AnnPopup>
    <div
      class="btn"
      :style="{ backgroundImage: `url(${goodsInfo.btnImageUrl})` }"
      @click="showPopAnn"
    ></div>
  </div>
</template>

<script>
import api from '@/api/api'
import { isGuest, requestappInfo } from '@/api/appInfo'
import config from '@/api/config'
import appInfo from '@/assets/js/appInfo'
import Urls from '@/assets/js/Urls'
import ym from '@/assets/js/ym.js'
import util from '@/util/util'
import { Log, getClientInfo } from '@em/ym'
import { Toast } from 'vant'
import AnnPopup from './components/AnnPopup'
let activityId = appInfo.getParam('activityId') || '1008'

export default {
  components: {
    AnnPopup
  },
  data() {
    return {
      annPop: false,
      // 商品信息
      goodsInfo: {}
    }
  },
  mounted() {
    requestappInfo()
    getClientInfo(() => {
      if (isGuest()) {
        util.go('ycstock://login')
        return
      }
    })
    this.getTemplateData()
    this.$onResume(() => {
      requestappInfo()
      getClientInfo()
    })

    Log.pageView({
      pageId: 'Html:Activity:ticketSales'
    })
    ym.showMenuItems({
      menuItems: [
        {
          callback: () => {
            ym.showSharePop({
              title: this.goodsInfo.title,
              content: '有看投',
              url: `${config.h5Url}/ticket-sales/?activityId=${activityId}&appId=31&wxAppId=wx738f0151ab06d507`
            })
          },
          icon:
            'https://appstatic.emoney.cn/images/20210419/9365ccedef860827d27e3ac32c638071.png'
        }
      ]
    })
  },
  methods: {
    getTemplateData() {
      api.activity
        .getPicTemplate()
        .then(({ detail, result }) => {
          if (detail) {
            this.goodsInfo = detail
            // console.log(detail, 66463)
          } else {
            Toast({ message: result.msg || '服务异常' })
          }
        })
        .catch(e => {
          console.log(e)
          Toast({ message: '服务异常', className: 'myToast' })
        })
    },
    showPopAnn() {
      this.annPop = true
    },
    openCashierDesk(val) {
      if (isGuest()) {
        util.go('ycstock://login')
        return
      }
      Log.click({
        eventId: 'RequestPayment'
      })
      let that = this
      api.activity
        .submitApi(val)
        .then(({ detail }) => {
          if (detail) {
            const params = `goodsId=${that.goodsInfo.goodsId}&goodsSetId=${that.goodsInfo.goodsSetId}&setId=${that.goodsInfo.goodsSetId}&extend=${detail}`
            let uri =
              'ycstock://web?url=' +
              escape(`${Urls.DOMAIN_YOUKANTOUWAP}/ykt-cashier/?${params}`)
            util.go(uri)
          }
        })
        .catch(e => {
          console.log(e)
          Toast({ message: '服务异常', className: 'myToast' })
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.page {
  background: #02013d;
  padding-bottom: 100px;
}
.img {
  width: 100%;
}
.btn {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 153px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}
</style>
